import type { ReactNode } from 'react';
import { OpenFeatureTestProvider } from '@openfeature/react-sdk';
import type { FlagValue } from '../types';

interface MockFeatureFlagProviderProps {
  flags: Record<string, FlagValue>;
  children: ReactNode;
}

export function MockFeatureFlagProvider({ flags, children }: MockFeatureFlagProviderProps) {
  return <OpenFeatureTestProvider flagValueMap={flags}>{children}</OpenFeatureTestProvider>;
}
